import { OnInit, EventEmitter } from '@angular/core';
var ToolButtonComponent = /** @class */ (function () {
    function ToolButtonComponent() {
        this.click = new EventEmitter();
        this.iconClass = 'fa fa-question';
        this.propagate = false;
        this.badgeColor = 'badge-primary';
        this.badge = '';
        this.badgeActive = false;
        this.isFile = false;
    }
    Object.defineProperty(ToolButtonComponent.prototype, "disabled", {
        get: function () {
            return this.disabledValue;
        },
        set: function (dis) {
            this.disabledValue = dis;
            this.color = this.colorValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolButtonComponent.prototype, "color", {
        get: function () {
            return this.colorValue;
        },
        set: function (col) {
            this.colorValue = col;
            this.colorClass = 'actions-bar__button-icon';
            if (this.colorValue !== undefined) {
                if (!this.disabled) {
                    this.colorClass += ' ' + this.colorValue;
                }
                else {
                    this.colorClass += ' has-color-gray';
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ToolButtonComponent.prototype.ngOnInit = function () {
        this.badgeClass = 'badge badge-pill badge-pill-floating-right ';
        if (this.iconClass !== undefined) {
            this.iconClass = 'fa ' + this.icon;
        }
        if (this.isFile === null || this.isFile === undefined || this.isFile === false) {
            this.tipuCamp = 'hidden';
        }
        else {
            this.tipuCamp = 'file';
        }
    };
    ToolButtonComponent.prototype.clickEvent = function (event) {
        if (!this.isFile) {
            if (!this.propagate) {
                event.stopPropagation();
            }
            if (!this.disabled) {
                this.click.emit(event);
            }
        }
    };
    ToolButtonComponent.prototype.fileReady = function (event) {
        if (!this.disabled) {
            this.click.emit(event);
        }
    };
    return ToolButtonComponent;
}());
export { ToolButtonComponent };
